import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Spin } from 'antd';
import { AUTH_MODE } from '@/config/constants';
import { shouldRedirectToSdpmSso } from '@/utils/authRouting';
import { can } from '@shared/utils';

interface ProtectedRouteProps {
  children: React.ReactNode;
  /**
   * Danh sách role được phép truy cập route này.
   * Nếu không truyền, chỉ cần đăng nhập là được.
   */
  allowedRoles?: string[];
  requiredPermission?: {
    resource: string;
    action: string;
  };
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  allowedRoles,
  requiredPermission,
}) => {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  if (!isAuthenticated) {
    if (typeof window !== 'undefined') {
      const hostname = window.location.hostname.toLowerCase();
      if (shouldRedirectToSdpmSso(hostname, AUTH_MODE)) {
        window.location.replace('https://sdpm.vn/login');
        return null;
      }
    }

    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    return <Navigate to="/personal/profile" replace />;
  }

  if (requiredPermission && !can(user, requiredPermission.resource, requiredPermission.action)) {
    return <Navigate to="/personal/profile" replace />;
  }

  return <>{children}</>;
};
